import { Link, useLocation } from 'react-router-dom';
import { SURFACE_META, shouldShowSwitcher, surfaceForPath, type Surface } from '~/lib/surfaces';
import { useT } from '~/i18n';

interface Props {
  surfaces: Surface[];
}

/**
 * El cambio de sombrero. Chips en la barra, el activo marcado como la ruta
 * activa del nav — mismo gesto, mismo púrpura.
 *
 * Discreto por diseño: NO es la navegación de nadie, es la puerta entre tres
 * apps que comparten una sesión. Por eso vive en la barra y no en el riel, no
 * lleva icono, y desaparece entero para quien sólo tiene una superficie (la
 * inmensa mayoría: un candidato jamás debe enterarse de que existe una consola
 * de operación).
 *
 * Cada chip apunta a la PORTADA de su superficie, no a la última ruta visitada
 * allá. Volver a "Agencia" y aterrizar en el detalle de una vacante que ya se
 * cerró es peor que aterrizar siempre en el resumen.
 */
export default function SurfaceSwitcher({ surfaces }: Props) {
  const { pathname } = useLocation();
  const t = useT('common');

  if (!shouldShowSwitcher(surfaces)) return null;

  const current = surfaceForPath(pathname);

  return (
    <nav className="switcher" aria-label={t.surfaces.switcherLabel}>
      {surfaces.map((surface) => {
        const meta = SURFACE_META[surface];
        const active = surface === current;
        return (
          <Link
            key={surface}
            to={meta.home}
            className="chip switcher__chip"
            // aria-current, no aria-pressed: esto navega, no conmuta un filtro.
            aria-current={active ? 'page' : undefined}
            data-active={active ? 'true' : undefined}
          >
            {t.surfaces[surface]}
          </Link>
        );
      })}
    </nav>
  );
}
